module.exports = __webpack_public_path__ + "static/img/gjsc2.c6a1c1d.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/common/gjsc2.jpg
// module id = 4mdC
// module chunks = 0